import {
  ApiGetRequest,
  ApiPostRequest,
  ApiDeleteRequest,
  ApiPutRequest,
  ApiPostMultipart,
  ApiBlobGetRequest,
} from '../../api';
import { showNotif } from '../notification';
import moment from 'moment-mini';

export const state = {
  data: {
    title: 'Pembelian Silver',
    title_gold: 'Pembelian Gold',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/opr',
      },
      {
        text: 'Pembelian',
        href: '/adm/purchase',
        active: true,
      },
    ],
    breadcrumb_gold: [
      {
        text: 'Dashboard',
        href: '/opr',
      },
      {
        text: 'Pembelian',
        href: '/adm/purchase-gold',
        active: true,
      },
    ],
    showmodal: false,
    items: [],
    totalRows: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_purchase',
    sortDesc: true,
    fields: [
      {
        key: 'no',
        label: 'No',
        thStyle: {
          width: '50px',
        },
      },
      {
        key: 'tgl_purchase',
        label: 'Tanggal',
        sortable: true,
        thStyle: {
          width: '150px',
        },
      },
      {
        key: 'code_purchase',
        label: 'Kode',
        sortable: true,
        thStyle: {
          width: '150px',
        },
      },
      {
        key: 'dist_name',
        label: 'Distributor',
        sortable: true,
      },
      {
        key: 'nama_pabrik',
        label: 'Pabrik',
        sortable: true,
      },
      {
        key: 'aksi',
        label: 'Aksi',
        thStyle: {
          width: '100px',
        },
      },
    ],
    fields_gold: [
      {
        key: 'no',
        label: 'No',
        thStyle: {
          width: '50px',
        },
      },
      {
        key: 'tgl_purchase',
        label: 'Tanggal',
        sortable: true,
        thStyle: {
          width: '120px',
        },
      },
      {
        key: 'code_purchase',
        label: 'Kode',
        sortable: true,
        thStyle: {
          width: '120px',
        },
      },
      {
        key: 'dist_name',
        label: 'Distributor',
        sortable: true,
      },
      {
        key: 'no_trans',
        label: 'No Transaksi',
      },
      {
        key: 'nama_pabrik',
        label: 'Pabrik',
      },
      {
        key: 'total',
        label: 'Total',
      },
      {
        key: 'ppn',
        label: 'PPN',
      },
      {
        key: 'total_final',
        label: 'Total Final',
      },
      {
        key: 'status_purchase',
        label: 'Status',
      },
      {
        key: 'aksi',
        label: 'Aksi',
        thStyle: {
          width: '100px',
        },
      },
    ],
    detail: {
      dist_company: '',
    },
    form: {},
    import_form: [],
    member: '',
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
  detail(state) {
    return state.data.detail;
  },
  import_form(state) {
    return state.data.import_form;
  },
};

export const mutations = {
  changePurchase(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async searchPurchase(context, params = null) {
    let result = await ApiGetRequest(`purchase`, params);
    return !result.error ? result.data.object : [];
  },

  async getListPurchase({ commit, state }, payload = {}) {
    commit('changePurchase', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      id_distributor: data.id_distributor ? data.id_distributor : '',
      ...payload,
      start_date:
        payload &&
        payload.date_filter &&
        payload.date_filter.length > 0 &&
        payload.date_filter[0]
          ? moment(payload.date_filter[0]).format('YYYY-MM-DD')
          : '',
      end_date:
        payload &&
        payload.date_filter &&
        payload.date_filter.length > 1 &&
        payload.date_filter[1]
          ? moment(payload.date_filter[1]).format('YYYY-MM-DD')
          : '',
      member: data.member,
    };

    if (payload && payload.export) {
      let result = await ApiBlobGetRequest(`purchase`, params);
      commit('changePurchase', {
        loading: false,
      });

      if (result.error) {
        return false;
      } else {
        // The actual download
        var blob = new Blob([result.data], {
          type:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'report_purchase.xlsx';

        document.body.appendChild(link);

        link.click();
        document.body.removeChild(link);

        return true;
      }
    } else {
      let result = await ApiGetRequest(`purchase`, params);
      commit('changePurchase', {
        items: !result.error ? result.data.object : [],
        total: !result.error ? result.data.total : 0,
        loading: false,
      });

      return !result.error ? true : false;
    }
  },

  async getDetailPurchase({ commit }, payload = null) {
    commit('changePurchase', {
      loading: true,
    });

    let result = await ApiGetRequest(`purchase/${payload.id}`);
    commit('changePurchase', {
      loading: false,
      detail: result.error ? false : result.data.object,
    });

    return result.error ? false : true;
  },

  async uploadImagePurchase({ commit, state }, payload) {
    commit('changePurchase', {
      loading: true,
    });

    const { data } = state;
    const result = await ApiPostMultipart(`upload-image`, payload);
    commit('changePurchase', {
      loading: false,
    });

    if (!result.error) {
      commit('changePurchase', {
        form: {
          ...data.form,
          prod_img: result.data.object.path,
        },
      });

      return true;
    }

    return false;
  },

  async importData({ commit, dispatch, state }) {
    commit('changePurchase', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest(`purchase/import`, {
      items: data.import_form || [],
    });

    commit('changePurchase', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async createPurchase({ commit, state, dispatch }) {
    commit('changePurchase', {
      loading: true,
    });

    let result = await ApiPostRequest(`purchase`, state.data.form);
    commit('changePurchase', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async updatePurchase({ commit, state, dispatch }, payload = null) {
    commit('changePurchase', {
      loading: true,
    });

    let result = await ApiPutRequest(`purchase/${payload.id}`, state.data.form);

    commit('changePurchase', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async deletePurchase({ commit, dispatch }, payload = null) {
    commit('changePurchase', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`purchase/${payload.id}`);
    commit('changePurchase', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },
};
